// Decorative SVG Components (React JS version)

// Top Corner
export const TopCorner = () => {
  return (
    <svg
      className="pointer-events-none absolute top-0 left-0 w-full"
      viewBox="0 0 800 220"
      preserveAspectRatio="none"
    >
      <path d="M0,0 L800,0 L800,60 C640,170 420,190 220,150 C120,130 50,110 0,90 Z" fill="rgba(247,234,208,0.55)" />
      <path d="M0,0 L800,0 L800,42 C640,150 420,170 220,128 C120,108 50,88 0,68 Z" fill="#c8a86a" />
      <path d="M0,0 L800,0 L800,28 C640,132 420,150 220,108 C120,90 50,72 0,54 Z" fill="#f7ead0" />
      <path d="M0,0 L800,0 L800,20 C640,118 420,134 220,94 C120,76 50,60 0,42 Z" fill="#3D2C96" />

      <circle cx="180" cy="118" r="2.5" fill="#c8a86a" />
      <circle cx="320" cy="138" r="2.5" fill="#c8a86a" />
      <circle cx="460" cy="142" r="2.5" fill="#c8a86a" />
      <circle cx="600" cy="130" r="2.5" fill="#c8a86a" />

      <path d="M0,0 C8,40 14,90 14,140 C14,180 8,210 0,220 Z" fill="#3D2C96" />
      <path d="M0,0 C16,30 22,80 26,130 C28,170 22,200 14,220 C14,180 8,140 0,100 Z" fill="#c8a86a" />

      <circle cx="10" cy="180" r="2.5" fill="#f7ead0" />
      <circle cx="18" cy="210" r="2" fill="#f7ead0" />
    </svg>
  );
};

// Bottom Corner
export const BottomCorner = () => {
  return (
    <svg
      className="pointer-events-none absolute bottom-0 right-0 w-full"
      viewBox="0 0 800 220"
      preserveAspectRatio="none"
    >
      <path d="M0,220 L800,220 L800,110 C640,40 420,30 220,70 C120,90 50,110 0,140 Z" fill="rgba(247,234,208,0.55)" />
      <path d="M0,220 L800,220 L800,150 C640,82 420,72 220,110 C120,128 50,142 0,168 Z" fill="#c8a86a" />
      <path d="M0,220 L800,220 L800,168 C640,102 420,92 220,128 C120,144 50,158 0,180 Z" fill="#f7ead0" />
      <path d="M0,220 L800,220 L800,182 C640,118 420,108 220,142 C120,156 50,170 0,190 Z" fill="#3D2C96" />

      <circle cx="200" cy="148" r="2.5" fill="#c8a86a" />
      <circle cx="340" cy="128" r="2.5" fill="#c8a86a" />
      <circle cx="480" cy="118" r="2.5" fill="#c8a86a" />
      <circle cx="620" cy="118" r="2.5" fill="#c8a86a" />

      <path d="M800,220 C792,180 786,130 786,80 C786,40 792,10 800,0 Z" fill="#3D2C96" />
      <path d="M800,220 C784,190 778,140 774,90 C772,50 778,20 786,0 C786,40 792,80 800,120 Z" fill="#c8a86a" />

      <circle cx="790" cy="40" r="2.5" fill="#f7ead0" />
      <circle cx="782" cy="10" r="2" fill="#f7ead0" />
    </svg>
  );
};

// Divider
export const Flourish = ({ className = "" }) => {
  return (
    <svg viewBox="0 0 400 24" className={className}>
      <line x1="20" y1="12" x2="170" y2="12" stroke="#c8a86a" />
      <line x1="230" y1="12" x2="380" y2="12" stroke="#c8a86a" />
      <circle cx="180" cy="12" r="1.8" fill="#c8a86a" />
      <circle cx="220" cy="12" r="1.8" fill="#c8a86a" />
    </svg>
  );
};

// Logo
export const Monogram = ({ className = "" }) => {
  return (
    <svg viewBox="0 0 120 120" className={className}>
      <circle cx="60" cy="60" r="56" fill="none" stroke="#3D2C96" />
      <circle cx="60" cy="60" r="50" fill="none" stroke="#c8a86a" />
      <circle cx="60" cy="60" r="42" fill="#3D2C96" />

      <text x="60" y="70" textAnchor="middle" fontSize="28" fill="#f7ead0">
        BV
      </text>
    </svg>
  );
};